import React from 'react';
import AsyncSelect from 'react-select/async';
import { useState } from 'react';
import api from '../../../services/API';
import './styles.css';
import { useSelector } from 'react-redux';

export default function SelectRevenda(props, ref) {
  const [revendas, setRevendas] = useState([]);

  const { cpf: cpfUsuario } = useSelector((state) => {
    return state.usuario;
  });

  const carregaPrimeiraVez = async () => {
    const resultado = await api.get(`/api/revendas?&cpfUsuario=${cpfUsuario}`);

    const valores = [];

    resultado.data.revendas.forEach((revenda) =>
      valores.push({
        value: revenda.cnpj,
        label: `${revenda.codigo} - ${revenda.nomeFantasia}`,
      })
    );

    setRevendas(valores);
    return valores;
  };

  const filtrarRevenda = async (valor) =>
    await revendas.filter((revenda) =>
      revenda.label.toLowerCase().includes(valor)
    );

  const carregarRevendas = (valor) =>
    revendas.length === 0 ? carregaPrimeiraVez() : filtrarRevenda(valor);

  return (
    <AsyncSelect
      noOptionsMessage={() => 'Sem resultados'}
      onChange={props.onChange}
      placeholder="Selecione uma Loja"
      className="react-select-container mb-3"
      classNamePrefix="react-select"
      cacheOptions
      defaultOptions
      loadOptions={carregarRevendas}
      theme={(theme) => ({
        ...theme,
        colors: {
          ...theme.colors,
          text: 'black',
          primary25: '#005a99',
          primary: '#005a99',
        },
      })}
    />
  );
}
